// extracted by mini-css-extract-plugin
module.exports = {"BasePill":"_3jJB0dMg","large":"nU2TB3ur","small":"_2yggjKq7"};